import { all } from 'redux-saga/effects';
import mealsSaga from './ducks/Meals/saga';
import authSaga from './ducks/Auth/saga';
import ordersSaga from './ducks/Orders/saga';
import ordersDetailSaga from './ducks/OrdersDetail/saga';
import ingredientsSaga from './ducks/Ingredients/saga';
import globalSaga from './ducks/Global/saga';
import videoLibrarySaga from './ducks/VideoLibrary/saga';
import stripeSaga from './ducks/Stripe/saga';
import mealPlanSaga from './ducks/MealPlan/saga';
import scheduledStreamSaga from './ducks/ScheduledStream/saga';

export default function* rootSaga() {
  yield all([
    mealsSaga(),
    authSaga(),
    ordersSaga(),
    ordersDetailSaga(),
    ingredientsSaga(),
    globalSaga(),
    videoLibrarySaga(),
    stripeSaga(),
    mealPlanSaga(),
    scheduledStreamSaga(),
  ]);
}
